// extracted by mini-css-extract-plugin
export default {"List":"MainPage_List__atlE0","ItemList":"MainPage_ItemList__CyFpi","Button":"MainPage_Button__UwLv8","LogoutButton":"MainPage_LogoutButton__I9U7J","Card":"MainPage_Card__8zBGf"};